import { SecondaryEmailResponse } from 'src/models/user.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectSelectedSecondaryEmailFromState = (
  state: RootState,
): string | undefined =>
  state.app.profile.secondaryEmails.selectedSecondaryEmail
export const selectSecondaryEmailsFromState = (
  state: RootState,
): SecondaryEmailResponse[] => state.app.profile.secondaryEmails.secondaryEmails
export const selectSecondaryEmailLoadingFromState = (
  state: RootState,
): boolean => state.app.profile.secondaryEmails.secondaryEmailLoading
export const selectSecondaryEmailTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.profile.secondaryEmails.secondaryEmailTopLevelError
export const selectResendVerificationCodeLoadingFromState = (
  state: RootState,
): boolean => state.app.profile.secondaryEmails.resendVerificationCodeLoading
export const selectResendVerificationCodeTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.profile.secondaryEmails.resendVerificationCodeTopLevelError
export const selectVerifySecondaryEmailLoadingFromState = (
  state: RootState,
): boolean => state.app.profile.secondaryEmails.verifySecondaryEmailLoading
export const selectVerifySecondaryEmailTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.profile.secondaryEmails.verifySecondaryEmailTopLevelError
export const selectFetchingSecondaryEmailsFromState = (
  state: RootState,
): boolean => state.app.profile.secondaryEmails.fetchingSecondaryEmails
